import React from 'react'
import GenericTitleP from '../../titles/GenericTitleP'
import ReturningVsFirstTimeChart from './returningVsFirstTimeChart/ReturningVsFirstTimeChart'
import { Row, Col } from 'react-bootstrap'
import ListStat from './listStat/ListStat'


const UserStatistics = () => {
  return (
    <div>
      <GenericTitleP>User Statistics In The Last Quarter</GenericTitleP>
      <Row>
        <Col lg={4} className='p-4'>
          <ListStat span="42%" color="success" text=" of all users made multiple purchases"/>
          <ListStat span="44%" color="info" text=" of users made only one purchase"/>
          <ListStat span="19%" color="primary" text=" of all users made more than 1000 $ purchase"/>
          <ListStat span="12%" color="danger" text=" of all users created a cart but never made a purchase In the last"/>
        </Col>
        <Col lg={8}>
          <ReturningVsFirstTimeChart />
        </Col>
      </Row>
    </div>
  )
} 

export default UserStatistics